const currentUrl = new URL(window.location.href);

if (currentUrl.searchParams.get('reauth') === 'true' && localStorage.getItem('signup_email')) {
    const registrationElement = document.getElementById('storebuilder-registration');
    const introElement = document.getElementById('gt-pastel-stepper');

    if (registrationElement) {
        registrationElement.classList.add('hidden');
    }

    if (introElement) {
        introElement.classList.remove('hidden');
    }


}else{

}


document.addEventListener("DOMContentLoaded", function () {
    // Initialize all HSStepper instances
    // Initialize all HSStepper instances
    HSStepper.autoInit();
    showbrowser();

    // Retrieve the stepper instance
    const stepperElement = document.querySelector("#stepper");
    const stepperInstance = HSStepper.getInstance(stepperElement);

    const introButton = document.getElementById("intro-button");
    const stepper = document.getElementById("gt-pastel-stepper");
    const intro = document.getElementById("storebuilder-intro");
    const rejectupsell = document.getElementById("reject-upsell");
    const congrats = document.getElementById("congrats-step");
    const upsell = document.getElementById('storebuilder-upsell');
    const activation = document.getElementById("zendrop-activation-button");





    introButton.addEventListener("click", function () {
        intro.classList.add("hidden");
        stepper.classList.remove("hidden");
        sendAnalytics('Upsell', 'user went on upsell');
    });

    rejectupsell.addEventListener("click", function () {
       upsell.classList.add("hidden");
        congrats.classList.remove("hidden");
        sendAnalytics('Upsell', 'user rejected upsell');

    });











    stepperInstance.on("next", (currentIndex) => {
        document.getElementById("next-button").disabled = true;

        getCurrentTitle(currentIndex);
        isShopify(currentIndex);
        isActivation(currentIndex);
        isInfo(currentIndex);
        isGoLive(currentIndex);
        stepCollector(currentIndex);
    });

    stepperInstance.on("back", (currentIndex) => {
        document.getElementById("next-button").disabled = true;

        getCurrentTitle(currentIndex);
        isShopify(currentIndex);
        isActivation(currentIndex);
        isInfo(currentIndex);
        isGoLive(currentIndex);

    });



    getCurrentTitle(1);

    document.getElementById("next-button").addEventListener("click", function (event) {
        //current step


        if (stepperInstance.currentIndex === 4) {
            HSOverlay.open("#shopify-modal");
        }
         else if (stepperInstance.currentIndex === 5) {
            checkZendropAppStatus(5, stepperInstance);
        } else if (stepperInstance.currentIndex === 6) {
            (async () => {
                try {
                    const subscriptionStatus = await checkShopifySubscription();
                    if (subscriptionStatus === "success") {
                        const buildStatus = await buildStore();
                        if (buildStatus === "success") {
                            HSOverlay.open("#zendrop-modal-building");
                            const intervalId = setInterval(async () => {
                                const progressStatus = await checkProgressStore();
                                console.log(progressStatus);

                                if (progressStatus) {
                                    clearInterval(intervalId);
                                    HSOverlay.close("#zendrop-modal-building");
                                    stepperInstance.goToNext();
                                    const backdrop = document.getElementById("zendrop-modal-building-backdrop");
                                    if (backdrop) {
                                        // Remove the backdrop
                                        backdrop.remove();
                                    }

                                }
                            }, 5000); // Check every 5 seconds
                        }
                    } else {
                        HSOverlay.open("#shopify-modal-activate");
                    }
                } catch (error) {
                    console.error("An error occurred:", error);
                }
            })();
        } else {
            stepperInstance.goToNext();
        }
    });

    document.getElementById("verify-shopify-plan").addEventListener("click", async function () {
        const verifyButton = document.getElementById("verify-shopify-plan");
        const originalText = verifyButton.innerHTML;
        verifyButton.innerHTML = "Verifying...";

        try {
            const subscriptionStatus = await checkShopifySubscription();
            if (subscriptionStatus === "success") {
                const buildStatus = await buildStore();
                if (buildStatus === "success") {
                    const progressStatus = await checkProgressStore();
                    if (!progressStatus) {
                        HSOverlay.close("#shopify-modal-activate");
                        //remove backdrop
                        const backdrop = document.getElementById("shopify-modal-activate-backdrop");
                        if (backdrop) {
                            backdrop.remove();
                        }
                    }
                }
            } else {
                let message = document.getElementById("shopify-activation-message");
                message.innerHTML = "Please make sure you have subscribed to Shopify’s Basic Monthly Plan. Refer to the instructions above.";
                message.style.display = 'block';
            }
        } catch (error) {
            console.error("An error occurred:", error);
        } finally {
            verifyButton.innerHTML = originalText;
        }
    });
    const shopifyplansbutton = document.getElementById("shopify-plans-button");

    shopifyplansbutton.addEventListener("click", function () {
        let store = getStoreUrl();
        window.open("https://admin.shopify.com/subscription/pick_period/basic/monthly?online=true&selected=true", "_blank");

    });
});

function getCurrentTitle(index) {
    let title = document.getElementById("data-step-item-" + index);
    let next = document.getElementById("data-step-item-" + (index + 1));
    const nextButtonArrow = document.querySelectorAll(".next-button-arrow");
    const PrevButtonArrow = document.querySelectorAll(".prev-btn-arrow");

    let titleText = title.innerHTML.trim();
    let words = titleText.split(" ");

    if (words.length > 1) {
        let lastWord = words.pop();
        let styledLastWord = `<span style="background: linear-gradient(12deg, #8472ED 8.11%, #B786F6 49.43%); background-clip: text; -webkit-background-clip: text; -webkit-text-fill-color: transparent;">${lastWord}</span>`;
        titleText = words.join(" ") + " " + styledLastWord;
    }

    document.getElementById("step-title").innerHTML = titleText;
    if (next) {
        document.getElementById("next-button").innerHTML =
            "Next: " + next.innerHTML;
    }

    if(index > 3){
        nextButtonArrow[0].style.display = "none";
        PrevButtonArrow[0].style.display = "none";
    }
    
}

function isShopify(index) {
    let shopify = document.getElementById("data-step-item-" + index);
    const nextButton = document.getElementById("next-button");

    if (shopify.getAttribute("data-item-type") === "shopify") {
        const shopifyButton = document.getElementById("shopify-button");
        shopifyButton.style.display = "block";

        shopifyButton.addEventListener("click", function () {
            const url = shopify.getAttribute("data-item-url");
            if (url) {
                window.open(url, "_blank");

                // Enable the next button
                nextButton.removeAttribute("disabled");
            }
        });
    } else {
        document.getElementById("shopify-button").style.display = "none";
    }
}

function isActivation(index) {
    let activation = document.getElementById("data-step-item-" + index);
    const nextButton = document.getElementById("next-button");
    const activationButton = document.getElementById("shopify-activation-button");

    // Hide next button on activation step
    if (activation.getAttribute("data-item-type") === "activation") {
        activationButton.style.display = "block";

        activationButton.addEventListener("click", function () {
            window.open("https://apps.shopify.com/zendrop", "_blank");

            // Enable the next button
            nextButton.removeAttribute("disabled");
        });
    } else {
        nextButton.style.display = "block";
        activationButton.style.display = "none";
    }
}

function isInfo(index) {
    const nextButton = document.getElementById("next-button");
    let info = document.getElementById("data-step-item-" + index);

    if (info.getAttribute("data-item-type") === "instructions") {
        console.log("info");
        // Initially disable the next button
        nextButton.removeAttribute("disabled");
    }
}

function isGoLive(index) {
    const nextButton = document.getElementById("next-button");
    let info = document.getElementById("data-step-item-" + index);

    const upsell = document.getElementById('storebuilder-upsell');
    const stepper = document.getElementById("gt-pastel-stepper");
    const myStorebutton = document.getElementById("access-shopify");


    if (info.getAttribute("data-item-type") === "live") {
        console.log("live");
        // Initially disable the next button
        nextButton.removeAttribute("disabled");
        myStorebutton.style.display = "block";

        myStorebutton.addEventListener("click", function () {
            const storeId = getStoreUrl();
            window.open("https://admin.shopify.com/store/" + storeId + '/themes', "_blank");
        });

        // Set the text of the next button
        nextButton.textContent = "Next: Success!";


        // Add event listener to the next button
        nextButton.addEventListener("click", () => {
            upsell.classList.remove("hidden");
            stepper.classList.add("hidden");
        });
    }
}

function checkZendropAppStatus(index, stepperInstance) {
    sendCheckZendropAppRequest()
        .then((status) => {
            if (status === "success") {
                HSOverlay.close("#zendrop-modal");
                stepperInstance.goToNext();
                const backdrop = document.getElementById("zendrop-modal-backdrop");
                if (backdrop) {
                    // Remove the backdrop
                    backdrop.remove();
                }
            } else {
                HSOverlay.open("#zendrop-modal");
            }
        })
        .catch((error) => {
            console.error("Error:", error);
        });

    const zendropActivationButton = document.getElementById(
        "zendrop-activation-button"
    );
    zendropActivationButton.addEventListener("click", function () {
        sendCheckZendropAppRequest()
            .then((status) => {
                if (status === "success") {
                    HSOverlay.close("#zendrop-modal");
                    const backdrop = document.getElementById("zendrop-modal-backdrop");
                    // Remove the backdrop
                    backdrop.remove();
                    // Enable the next button
                    nextButton.removeAttribute("disabled");
                } else {
                    let message = document.getElementById("zendrop-activation-message");
                    message.style.display = "block";
                    message.innerHTML = "Please install the Zendrop app to continue";
                    zendropActivationButton.innerHTML = `I have activated it`;
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    });
}

function sendCheckZendropAppRequest() {
    return new Promise((resolve, reject) => {
        //get local storage value signup_email
        const signupEmail = localStorage.getItem("signup_email");

        const payload = {
            action: "zendrop_check_zendrop_app",
            email: signupEmail,
        };

        fetch(ajax_object.ajaxurl, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: new URLSearchParams(payload).toString(),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.success) {
                    sendAnalytics('checking zendrop app','zendrop activated')
                    resolve("success");

                } else {
                    resolve("error");
                    sendAnalytics('checking zendrop app','zendrop is not activated')
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    });
}

function checkShopifySubscription() {
    return new Promise((resolve, reject) => {
        const signupEmail = localStorage.getItem("signup_email");
        const payload = {
            action: "zendrop_check_shopify_subscription",
            email: signupEmail,
        };

        fetch(ajax_object.ajaxurl, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: new URLSearchParams(payload).toString(),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.success) {
                    console.log(data.data['storeUrl']);

                    sendAnalytics('checking shopify','shopify activated')
                    //send shopify activation on hook
                    //set data.storeUrl in localstorage
                    localStorage.setItem("store_url", data.data['storeUrl']);
                    resolve("success");
                } else {
                    localStorage.setItem("store_url", data.data['storeUrl']);
                    sendAnalytics('checking shopify','shopify is not activated')
                    resolve("error");
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    });
}

function buildStore() {
    return new Promise((resolve, reject) => {
        const signupEmail = localStorage.getItem("signup_email");
        const payload = {
            action: "zendrop_build_store",
            email: signupEmail,
        };
        fetch(ajax_object.ajaxurl, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: new URLSearchParams(payload).toString(),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.success) {
                    resolve("success");
                } else {
                    resolve("error");
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    });
}

function checkProgressStore() {
    return new Promise((resolve, reject) => {
        const signupEmail = localStorage.getItem("signup_email");
        const payload = {
            action: "zendrop_check_progress_store",
            email: signupEmail,
        };
        fetch(ajax_object.ajaxurl, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: new URLSearchParams(payload).toString(),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.success) {
                    resolve(true);
                } else {
                    resolve(false);
                }
            })
            .catch((error) => {
                console.error("Error:", error);
                resolve(false);
            });
    });
}



function getStoreUrl() {
   let store = localStorage.getItem("store_url");
    return store.match(/^[^.]+/)
}



function sendAnalytics(step, value) {
    if (typeof dataLayer !== 'undefined' && dataLayer) {
        dataLayer.push({
            'event': 'step',
            'currentStep': step,
            'value': value,
            'email': localStorage.getItem("signup_email")
        });
    } else {
        console.warn('dataLayer is not initialized. Analytics event not sent.');
    }
}


function stepCollector(index) {
    let step = document.getElementById("data-step-item-" + (index-1));
    let title = step.getAttribute("data-item-type");
    let current = index-1;

    // Collect specific data for steps 1-3
    if (current === 1) {
        value = localStorage.getItem("selectedStyle") || "Not selected";
    } else if (current === 2) {
        value = localStorage.getItem("selectedColor") || "Not selected";
    } else if (current === 3) {
        value = localStorage.getItem("selectedStyle") || "Not selected";
    }
    // Log the collected data (you can remove this in production)
    console.log(`Step ${index}: ${title}, Value: ${value}`);
    sendAnalytics(title, value);


}

function showbrowser(){
    // Function to show the modal using HSOverlay
    function showModal() {
        HSOverlay.open('#zendrop-modal-browser');
    }

    // Function to check if the user is coming from an external browser
    function checkExternalBrowser() {
        const referrer = document.referrer.toLowerCase();
        const userAgent = navigator.userAgent.toLowerCase();

        // List of known in-app browser indicators
        const inAppBrowsers = [
            'instagram',
            'fbav',
            'fb_iab',
            'fban',
            'twitter',
            'tiktok',
            'youtube'
        ];

        // Check if the referrer or user agent contains any of the in-app browser indicators
        const isInAppBrowser = inAppBrowsers.some(browser =>
            referrer.includes(browser) || userAgent.includes(browser)
        );


        if (isInAppBrowser) {

            showModal();
        }
    }

    // Run the check when the page loads
    window.addEventListener('load', checkExternalBrowser);

    // Optional: Close modal when clicking outside
    document.addEventListener('click', function (event) {
        const modal = document.getElementById('zendrop-modal-browser');
        if (modal && !modal.contains(event.target)) {
            HSOverlay.close('#zendrop-modal-browser');
        }
    });
}